import { useMutation } from "react-query";
import { getAiSearchResponse } from "../../services/aiSearch";

/**
 * LLM/AI search mutation (POST article/ai-search).
 */
export function useAiSearchMutation() {
  return useMutation(({ query, product }) =>
    getAiSearchResponse({ query, product })
  );
}
